var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"gift",attrs:{"src":require("../../../../assets/image/live/gift.png")},on:{"click":_vm.showgift}})
}
var staticRenderFns = []

export { render, staticRenderFns }